export const MAX_UPLOAD_SIZE = 5_368_709_120;
